// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__4rY11","imageUploader":"EGiftCard_imageUploader__1TCmr"};